import { useRef } from "react";
import ModalPop from "./ModalPop";

interface ServiceItem {
  icon: string;
  title: string;
  /** 기본 설명(회색). 줄바꿈은 \n 으로 표현 */
  desc: string;
  /** 파란색으로 강조되는 두 번째 줄(선택) */
  highlight?: string;
}

const BLOG_URL = "https://blog.naver.com/pkpk1440";

const services: ServiceItem[] = [
  {
    icon: "/images/service1.png",
    title: "하수구 서비스",
    desc: "하수구 막힘 · 뚫음 · 역류해결",
    highlight: "전문장비를 통한 정확한 견적",
  },
  {
    icon: "/images/service2.png",
    title: "변기 서비스",
    desc: "변기 막힘 · 뚫음 · 역류해결",
    highlight: "과잉견적 절대 NO!",
  },
  {
    icon: "/images/service3.png",
    title: "싱크대 서비스",
    desc: "싱크대 막힘 · 뚫음 · 역류해결",
    highlight: "365일 긴급출동 서비스",
  },
  {
    icon: "/images/service4.png",
    title: "배관 서비스",
    desc: "배관 막힘 · 뚫음 · 역류해결",
    highlight: "타업체 실패현장 해결 전문가",
  },
  {
    icon: "/images/service5.png",
    title: "우수관",
    desc: "각종설비 막힘 · 뚫음 · 역류해결",
    highlight: "어떤 문제도 해결 가능",
  },
  {
    icon: "/images/service6.png",
    title: "오수관",
    desc: "각종설비 막힘 · 뚫음 · 역류해결",
    highlight: "어떤 문제도 해결 가능",
  },
  {
    icon: "/images/service7.png",
    title: "고압세척",
    desc: "강력한 수압으로\n배관 내부를 깨끗하게 세척합니다.",
  },
  {
    icon: "/images/service8.png",
    title: "에어컨 드레인 막힘",
    desc: "막힌 드레인 배관을 뚫고\n배수를 복구합니다.",
  },
  {
    icon: "/images/service9.png",
    title: "누수 · 방수",
    desc: "누수 원인을 찾아\n방수 및 보수합니다.",
  },
  {
    icon: "/images/service10.png",
    title: "해빙 · 동파",
    desc: "얼어붙은 배관을 녹이고\n동파를 복구합니다.",
  },
  {
    icon: "/images/service11.png",
    title: "수전 교환 · 수리",
    desc: "고장난 수전을 점검하고\n교체 · 수리합니다.",
  },
];

const Service = () => {
  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };

  return (
    <div id="services" className="relative w-full px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-24 xl:py-28">
      <ModalPop popupRef={popupRef} closefnc={closefunc} />

      <div className="mx-auto max-w-[1200px]">
        {/* 상단 타이틀 */}
        <div className="text-center" data-aos="fade-up">
          <h3 className=" font-medium text-xl md:text-2xl">
            쉽고 빠른 <span className="text-primary">하수구 해결 서비스</span>
          </h3>
          <h2 className="gbold text-secondary">다양한 서비스를 한곳에서 해결해보세요</h2>
          <p className="mx-auto my-5 text-base md:text-lg">
            각종&nbsp;설비&nbsp;관련&nbsp;서비스!
            막힘&nbsp;·&nbsp;뚫음&nbsp;·&nbsp;역류&nbsp;문제를&nbsp;깔끔하게&nbsp;해결합니다
          </p>
        </div>

        {/* Card grid */}
        <div className="mt-10 grid grid-cols-1 gap-4 lg:grid-cols-3 lg:gap-6 tracking-[-0.08em]">
          {services.map((service) => (
            <div
              key={service.title}
              data-aos="fade-up"
              className="flex flex-col rounded-2xl border border-primary bg-white p-7 text-left transition-shadow hover:shadow-lg md:p-6"
            >
              {/* Icon + title */}
              <div className="flex items-center gap-3">
                <img
                  src={service.icon}
                  alt={service.title}
                  loading="lazy"
                  decoding="async"
                  className="h-11 w-11 shrink-0"
                />
                <h3 className="gmedium font-medium text-secondary lg:text-3xl">{service.title}</h3>
              </div>

              {/* Description */}
              <div className="mt-4 flex-1">
                <p className="whitespace-pre-line leading-tight text-lightGray text-lg">{service.desc}</p>
                {service.highlight && (
                  <p className="-mt-1 lg:leading-tight text-primary text-lg">{service.highlight}</p>
                )}
              </div>

              {/* Buttons */}
              <div className="mt-5 flex flex-wrap gap-2">
                <button
                  type="button"
                  onClick={openfunc}
                  className="rounded-full bg-primary px-4 pb-1 pt-1.5 text-md font-medium text-white transition-transform hover:-translate-y-0.5"
                >
                  해결상담 서비스 ▶
                </button>
                <button
                  type="button"
                  onClick={() => window.open(BLOG_URL)}
                  className="rounded-full bg-secondary px-4 pb-1 pt-1.5 text-md font-medium text-white transition-transform hover:-translate-y-0.5"
                >
                  작업사례 확인 ▶
                </button>
              </div>
            </div>
          ))}

          {/* CTA card */}
          <div
            data-aos="fade-up"
            onClick={openfunc}
            className="relative flex cursor-pointer flex-col justify-between overflow-hidden rounded-2xl bg-gradient-to-l from-[#2b60cf] via-[#1a4198] to-[#0a1a4d] p-6 text-white transition-transform hover:-translate-y-0.5"
          >
            <p className="leading-snug text-lg lg:text-xl">
              과연, 해결이 가능할까?
              <br />
              고민이 되신다면
            </p>
            <div className="mt-8">
              <p className="text-lg lg:text-xl">답은 하수코 솔루션입니다</p>
              <p className="-mt-1 glight text-white/70 text-lg lg:text-xl">무료 상담 신청하기</p>
            </div>

            {/* 접힌 모서리(dog-ear) + CLICK */}
            <div className="pointer-events-none absolute bottom-0 right-0 h-[100px] w-[100px]">
              <div className="absolute inset-0 bg-white [clip-path:polygon(100%_0,0_100%,100%_100%)]" />
              <span className="absolute bottom-[16px] right-[2px] origin-center rotate-[-45deg] text-[11px] font-light tracking-widest text-secondary">
                CLICK
                <br />
                <img src="/images/iconArrow.png" alt="" aria-hidden="true" className="h-4 w-4 rotate-[40deg] mx-auto" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Service;
